import { render, staticRenderFns } from "./BK_base-dropdown-picker.vue?vue&type=template&id=124743b9&scoped=true&"
import script from "./BK_base-dropdown-picker.vue?vue&type=script&lang=js&"
export * from "./BK_base-dropdown-picker.vue?vue&type=script&lang=js&"
import style0 from "./BK_base-dropdown-picker.vue?vue&type=style&index=0&id=124743b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124743b9",
  null
  
)

export default component.exports